// extracted by mini-css-extract-plugin
export default {"workspace":"Workspace_workspace__qojxd","scrollable":"Workspace_scrollable__xDmuY","content":"Workspace_content__eepLJ"};